import React, { Component } from "react";
import ZPartnerLSC0Header from "./ZPartnerLSC0Header";
import ZPartnerLSC0Footer from "./ZPartnerLSC0Footer";

import { Redirect_Url_2 } from "./ZPartnerLSCUrls";

export class LSC_SigninReplaceActionSuccess extends Component {
    static displayName = LSC_SigninReplaceActionSuccess.name;

    constructor(props) {
        super(props);
        this.state = {
            message: ""
        };
    }

    componentDidMount() {
        //const links = [
        //    "https://fonts.googleapis.com/css?family=Lato:300&text=1234567890,.-",
        //    "/css/lsc/style_01.css",
        //    "/css/lsc/style_02.css",
        //    "/css/lsc/style_03.css",
        //    "/css/lsc/691208892_en-US.css",
        //    "/css/lsc/line_my_card.css"
        //];

        //links.forEach(href => {
        //    const link = document.createElement("link");
        //    link.rel = "stylesheet";
        //    link.href = href;
        //    document.head.appendChild(link);
        //});

        // read message from sessionStorage
        const errMessage = sessionStorage.getItem("lscErrorMsg") || "";
        this.setState({ message: errMessage });
    }

    handleSubmit = async (e) => {
        e.preventDefault();

        window.location.replace(Redirect_Url_2);
    };


    render() {
        const {
            message
        } = this.state;

        return (
            <>
                <ZPartnerLSC0Header />

                <main id="main">                    
                    <section className="section-sign-in overflow-hidden pb-5">
                        <div className="container p-1 p-md-0">
                            <div className="row">
                                <div className="col-md-12 mb-5 pt-3 text-center">
                                    <h2 className="h3 mt-5 fw-bold text-dark-212121"></h2>
                                </div>
                            </div>
                            <div className="row justify-content-center px-1 px-md-5">
                                <div className="col-md-6 mb-3 pt-3">
                                    <div className="py-5 p-4 box-sign-in">
                                        <form className="form-sr px-1" onSubmit={this.handleSubmit}>
                                            <div className="mb-4 text-center">
                                                <p>
                                                    ขอบคุณ<br />
                                                    บัญชี Starbucks® Rewards ของคุณได้ผูกกับบัญชี LINE ใหม่เรียบร้อยแล้ว
                                                </p>
                                                <p>
                                                    Thank you<br />
                                                Your Starbucks<sup>®</sup> Rewards account has been linked with the new LINE account.
                                                </p>
                                            </div>
                                            <div className="text-center">                                               
                                                <button className="btn btn-primary rounded-pill px-4">
                                                    เข้าสู่ LINE Starbucks Card<br />
                                                    Return to LINE Starbucks Card
                                                </button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </main>                

                <ZPartnerLSC0Footer />
            </>
        );
    }
}
